<template>
  <b-container id="main-container" fluid style>
    <b-row style="width: 100%; background-color: #e8e8ea" align-h="center">
      <b-col class cols="12">
        <nav-header ref="header"></nav-header>
      </b-col>
    </b-row>

    <b-row
      style="width: 100%; margin-top: 80px"
      class="main-jumbotron"
      align-h="center"
    >
      <b-col
        cols="12"
        lg="5"
        style="max-width: 1400px"
        class="pl-0 pr-0 hide-when-small"
      >
        <b-row data-aos="fade-right" data-aos-delay="250" style="height: 100%">
          <h1 style="font-size: 32px !important">Truthbrush</h1>
        </b-row>
      </b-col>
      <b-col cols="12" lg="7" style="max-width: 1400px" class="pl-0 pr-0">
        <b-navbar
          class="header-nav product-tab reduced_pl_pr"
          style="padding-top: 0; padding-bottom: 0"
        >
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-item href="" class="nav-bar-item">
              <b-button variant="light" v-if="index == 0" @click="index = 0"
                >Overview</b-button
              >
              <b-button
                class="button-unselect"
                variant="light"
                v-else
                @click="index = 0"
                >Overview</b-button
              ></b-nav-item
            >

            <b-nav-item href="" class="nav-bar-item">
              <b-button variant="light" v-if="index == 1" @click="index = 1"
                >Compare</b-button
              >
              <b-button
                class="button-unselect"
                variant="light"
                v-else
                @click="index = 1"
                >Compare</b-button
              >
            </b-nav-item>

            <b-nav-item href="" class="nav-bar-item">
              <b-button variant="light" v-if="index == 2" @click="index = 2"
                >Spec</b-button
              >
              <b-button
                class="button-unselect"
                variant="light"
                v-else
                @click="index = 2"
                >Spec</b-button
              >
            </b-nav-item>

            <b-nav-item href="" class="nav-bar-item">
              <b-button variant="light" v-if="index == 3" @click="index = 3"
                >Setup</b-button
              >
              <b-button
                class="button-unselect"
                variant="light"
                v-else
                @click="index = 3"
                >Setup</b-button
              >
            </b-nav-item>

            <b-nav-item href="/#/select" class="nav-bar-item nav-buy-button"
              ><b-button v-bind:style="getbuybuttonstyle()"
                >Buy now</b-button
              ></b-nav-item
            >
          </b-navbar-nav>
        </b-navbar>
      </b-col>
    </b-row>

    <b-row
      style="width: 100%"
      align-h="center"
      class="main-jumbotron"
      v-if="index == 0"
    >
      <b-col class="pl-0 pr-0">
        <b-row class="pt-3 pb-5">
          <b-col class="pr-0 pl-0">
            <VueSlickCarousel
              @afterChange="onPageChange"
              :arrows="false"
              :dots="true"
              :slidesToShow="1"
              :centerMode="true"
              :centerPadding="'5%'"
            >
              <div>
                <b-row>
                  <b-col class="pl-0 pr-0 prod-card card-1"> </b-col>
                </b-row>
              </div>
              <div>
                <b-row>
                  <b-col class="pl-0 pr-0 prod-card card-2"> </b-col>
                </b-row>
              </div>
              <div>
                <b-row>
                  <b-col class="pl-0 pr-0 prod-card card-3"> </b-col>
                </b-row>
              </div>
              <div>
                <b-row>
                  <b-col class="pl-0 pr-0 prod-card card-4"> </b-col>
                </b-row>
              </div>
              <div>
                <b-row>
                  <b-col class="pl-0 pr-0 prod-card card-5"> </b-col>
                </b-row>
              </div>
              <div>
                <b-row>
                  <b-col class="pl-0 pr-0 prod-card card-6"> </b-col>
                </b-row>
              </div>
              <div>
                <b-row>
                  <b-col class="pl-0 pr-0 prod-card card-7"> </b-col>
                </b-row>
              </div>
              <div>
                <b-row>
                  <b-col class="pl-0 pr-0 prod-card card-8"> </b-col>
                </b-row>
              </div>
              <div>
                <b-row>
                  <b-col class="pl-0 pr-0 prod-card card-9"> </b-col>
                </b-row>
              </div>
            </VueSlickCarousel>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row
      class="ml-0 mt-3 lead shopbtn pt-2 hide-when-big"
      align-v="center"
      v-if="index == 0"
    >
      <b-col style="text-align: center">
        <router-link to="/select">
          <b-button
            pill
            variant="primary"
            size="lg"
            center
            class="hub-blue btn-truthbrush"
            >Shop now</b-button
          >
        </router-link>
      </b-col>
    </b-row>

    <b-row
      v-if="index == 0"
      style="width: 100%; padding-top: 20px; padding-bottom: 0px"
      align-h="center"
      class="main-jumbotron pt-5"
      ref="irene"
    >
      <b-col class="pl-0 pr-0 h-padding-small">
        <b-row class="justify-content-center pb-3">
          <h1 style="max-width: 100%">
            Cultivating healthy habits for entire family
          </h1>
        </b-row>
        <b-row class="justify-content-center align-center sub-title2 pl-3 pr-2">
          Truthbrush changes the way that you interact, coach, and build
          positive habits with your family.
        </b-row>
        <b-row class="main-jumbotron pt-5" style="height: 100% !important">
          <b-col class="pl-0 pr-0">
            <VueSlickCarousel
              :arrows="false"
              :dots="true"
              :slidesToShow="3"
              :responsive="[
                {
                  'breakpoint': 500,
                  'settings':{
                    'slidesToShow':1
                  }
                },
                {
                  'breakpoint': 700,
                  'settings':{
                    'slidesToShow':2
                  }
                },
                {
                  'breakpoint': 1080,
                  'settings':{
                    'slidesToShow':3
                  }
                }
              
              ]"
            >
              <div>
                <b-col class="pl-3 pr-3">
                  <b-row class="">
                    <b-col>
                      <b-img
                        src="/img/product-sub1.png"
                        class="product-sub-image"
                        center
                        fluid
                      ></b-img>
                    </b-col>
                  </b-row>
                  <b-row class="justify-content-center three-question-title">
                    Fully automatic
                  </b-row>
                  <b-row class="three-question-description">
                    <b-col>
                    Truthbrush works seamlessly in the background. It knows when
                    brushing starts and ends.
                    </b-col>
                  </b-row>
                </b-col>
              </div>
              <div>
                <b-col class="pl-3 pr-3">
                  <b-row class="">
                    <b-col>
                      <b-img
                        src="/img/product-sub2.png"
                        center
                        class="product-sub-image"
                        fluid
                      ></b-img>
                    </b-col>
                  </b-row>
                  <b-row class="justify-content-center three-question-title">
                    No extra burden
                  </b-row>
                  <b-row class="three-question-description">
                    <b-col>
                    No button to press, phone to bring, app to open, or
                    Bluetooth to turn on.
                    </b-col>
                  </b-row>
                </b-col>
              </div>

              <div>
                <b-col class="pl-3 pr-3">
                  <b-row class="">
                    <b-col>
                      <b-img
                        src="/img/product-sub3.png"
                        center
                        class="product-sub-image"
                        fluid
                      ></b-img>
                    </b-col>
                  </b-row>
                  <b-row class="justify-content-center three-question-title">
                    Multi-user
                  </b-row>
                  <b-row class="three-question-description">
                    <b-col>
                    Dedicated Wifi Hub for reliable data collection for entire
                    family.
                    </b-col>
                  </b-row>
                </b-col>
              </div>
            </VueSlickCarousel>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row
      style="width: 100%; position: relative; padding-bottom: 60px"
      align-h="center"
      class="main-jumbotron pt-5 reduced-pb-0"
      v-if="index == 0"
    >
      <b-col class="pl-0 pr-0 hide-when-small" style="z-index: 999">
        <b-img-lazy
          src="/img/bg1-min.jpg"
          fluid
          center
          style="width: 100%"
        ></b-img-lazy>
      </b-col>

      <b-col class="pl-0 pr-0 hide-when-big" style="z-index: 999">
        <b-img-lazy src="/img/bg1a-min.jpg" fluid center></b-img-lazy>
      </b-col>

      <b-col style="z-index: 0; position: absolute; width: 1px; height: 1px">
        <div
          class="wistia_responsive_padding"
          style="padding: 56.25% 0 0 0; position: relative"
        >
          <div
            class="wistia_responsive_wrapper"
            style="
              height: 100%;
              left: 0;
              position: absolute;
              top: 0;
              width: 100%;
            "
          >
            <span
              class="
                wistia_embed wistia_async_xf65loyzdr
                popover=true
                popoverAnimateThumbnail=true
                videoFoam=true
              "
              style="
                display: inline-block;
                height: 100%;
                position: relative;
                width: 100%;
              "
              >&nbsp;</span
            >
          </div>
        </div>
      </b-col>

      <div
        style="position: absolute; left: 4%; z-index: 999; width: 96%"
        class="video-title-top-position2"
        data-aos="fade-up"
        data-aos-delay="250"
      >
        <div style="position: relative; left: -2%">
          <b-row
            class="blue-text justify-content-center"
            style="color: #82c431; padding-top:120px"
          >
            Trust but verify
          </b-row>

          <b-row class="justify-content-center pt-3">
            <h2 style="max-width: 820px; color: white; text-align: center">
              “Did you brush your teeth?” <br />You never have to ask this
              question again
            </h2>
          </b-row>
          <b-row style="justify-content: center; padding-top: 25px">
            <b-button
              pill
              size="lg"
              v-b-modal.trust-verify
              style="
                background-color: #82c431;
                border: none;
                padding: 10px 20px;
              "
            >
              Watch the video
            </b-button>
          </b-row>
        </div>
      </div>
    </b-row>

    <b-row
      class="main-jumbotron min-height-sp pt-5"
      style="height: 100% !important"
      v-if="index == 0"
    >
      <b-col class="background-product-2">
        <b-row data-aos="fade-up" data-aos-delay="250">
          <b-col
            cols="12"
            md="6"
            class="pl-pr-0-sm reduced-pt-20 reduced_pl_pr"
            style="padding-top: 120px"
          >
            <b-row class="blue-text justify-content-center">
              Easy to fit on
            </b-row>

            <b-row class="justify-content-center pt-3">
              <h1 style="max-width: 100%">Works with any toothbrush</h1>
            </b-row>
            <b-row
              class="
                justify-content-center
                align-center
                sub-title2
                pt-4
                pl-3
                pr-3
              "
            >
              Changing your toothbrush every 3-4 months? <br />
              Simply fit the tracker onto your new toothbrush.
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row v-if="index == 0" class="main-jumbotron">
      <b-col class="product-rainbow reduced-pt-20" style="padding-top: 150px">
        <b-row align-v="center" class="pb-5">
          <b-col cols="12" md="6">
            <b-img-lazy
              src="/img/product-5.png"
              center
              class="prod-desc-image mb-5"
            >
            </b-img-lazy>
          </b-col>
          <b-col cols="12" md="6" data-aos="fade-up" data-aos-delay="250">
            <b-row class="blue-text justify-content-center">
              Weekly performance
            </b-row>

            <b-row class="justify-content-center pt-3">
              <h1 style="max-width: 100%; text-align: center">
                View brush duration and count data
              </h1>
            </b-row>
            <b-row
              class="
                justify-content-center
                align-center
                sub-title2
                pt-4
                pl-3
                pr-3
              "
            >
              View weekly toothbrush performance just like you would with a
              fitness app. The chart is color coded to show morning vs.
              nighttime brushing. Viewing performance over time is a great way
              to identify patterns and make important changes.
            </b-row>
          </b-col>
        </b-row>

        <b-row align-v="center" class="pb-5">
          <b-col cols="12" md="6" class="hide-when-big">
            <b-img-lazy
              src="/img/product-2.png"
              center
              class="prod-desc-image mb-5"
            >
            </b-img-lazy>
          </b-col>
          <b-col cols="12" md="6" data-aos="fade-up" data-aos-delay="250">
            <b-row class="blue-text justify-content-center">
              Notifications
            </b-row>

            <b-row class="justify-content-center pt-3">
              <h1 style="max-width: 100%">Alerts and notifications</h1>
            </b-row>
            <b-row
              class="
                justify-content-center
                align-center
                sub-title2
                pt-4
                pl-3
                pr-3
              "
            >
              Alerts make it easy to know when a brush event has been skipped or
              activity is detected. Get the peace of mind that comes with
              knowing. Understanding behavior provides opportunities for
              positive coaching.
            </b-row>
          </b-col>
          <b-col cols="12" md="6" class="hide-when-small">
            <b-img-lazy
              src="/img/product-2.png"
              center
              class="prod-desc-image mb-5"
            >
            </b-img-lazy>
          </b-col>
        </b-row>

        <b-row align-v="center">
          <b-col cols="12" md="6">
            <b-img-lazy
              src="/img/product-1.png"
              center
              class="prod-desc-image mb-5"
            >
            </b-img-lazy>
          </b-col>
          <b-col
            cols="12"
            md="6"
            class="mb-5"
            data-aos="fade-up"
            data-aos-delay="250"
          >
            <b-row class="blue-text justify-content-center"> One app </b-row>

            <b-row class="justify-content-center pt-3">
              <h1 style="max-width: 100%">Track entire family</h1>
            </b-row>
            <b-row
              class="
                justify-content-center
                align-center
                sub-title2
                pt-4
                pl-3
                pr-3
              "
            >
              The Truthbrush app is designed to show results for the entire
              family. Most families will connect with a single hub, this makes
              it easy to connect your trackers and removes the reliance on the
              presence of any individuals phone.
            </b-row>
          </b-col>
        </b-row>

        <b-row align-v="center" class="pb-5">
          <b-col cols="12" md="6" class="hide-when-big">
            <b-img-lazy
              src="/img/product-4.png"
              center
              class="prod-desc-image mb-5"
            >
            </b-img-lazy>
          </b-col>
          <b-col cols="12" md="6" data-aos="fade-up" data-aos-delay="250">
            <b-row class="blue-text justify-content-center">
              Goals and Rewards
            </b-row>

            <b-row class="justify-content-center pt-3">
              <h1 style="max-width: 100%; text-align: center">
                Reward when weekly goals are achieved
              </h1>
            </b-row>
            <b-row
              class="
                justify-content-center
                align-center
                sub-title2
                pt-4
                pl-3
                pr-3
              "
            >
              Rewards can go a long way to building positive habits. Set
              attainable goals and let the Truthbrush app calculate the outcome.
              Provides a true incentive with the built-in allowance reward.
            </b-row>
          </b-col>
          <b-col cols="12" md="6" class="hide-when-small">
            <b-img-lazy
              src="/img/product-4.png"
              center
              class="prod-desc-image mb-5"
            >
            </b-img-lazy>
          </b-col>
        </b-row>

        <b-row align-v="center" class="pb-5">
          <b-col cols="12" md="6">
            <b-img-lazy
              src="/img/product-3.png"
              center
              class="prod-desc-image mb-5"
            >
            </b-img-lazy>
          </b-col>
          <b-col cols="12" md="6" data-aos="fade-up" data-aos-delay="250">
            <b-row class="blue-text justify-content-center">
              Configurable Timer
            </b-row>

            <b-row class="justify-content-center pt-3">
              <h1 style="max-width: 100%">Improve brushing duration</h1>
            </b-row>
            <b-row
              class="
                justify-content-center
                align-center
                sub-title2
                pt-4
                pl-3
                pr-3
              "
            >
              Truthbrush beeps after 2 minutes or any time that you configure.
              It’s automatic! There is no start button, it knows when you are
              brushing and beeps when the time is up.
            </b-row>
          </b-col>
        </b-row>

        <b-row align-v="center" class="pb-5">
          <b-col cols="12" md="6" class="hide-when-big">
            <b-img-lazy
              src="/img/product-6.png"
              center
              class="prod-desc-image mb-5"
            >
            </b-img-lazy>
          </b-col>
          <b-col cols="12" md="6" data-aos="fade-up" data-aos-delay="250">
            <b-row class="blue-text justify-content-center">
              Comparison and Ranking
            </b-row>

            <b-row class="justify-content-center pt-3">
              <h1 style="max-width: 100%; text-align: center">
                Your performance in your age group
              </h1>
            </b-row>
            <b-row
              class="
                justify-content-center
                align-center
                sub-title2
                pt-4
                pl-3
                pr-3
              "
            >
              Enter each Truthbrush user’s birthday in the mobile app to see how
              they compare against others in their age group. Feel pride in
              being at the top of the list or see rankings rise while building
              healthy habits.
            </b-row>
          </b-col>
          <b-col cols="12" md="6" class="hide-when-small">
            <b-img-lazy
              src="/img/product-6.png"
              center
              class="prod-desc-image mb-5"
            >
            </b-img-lazy>
          </b-col>
        </b-row>

        <b-row align-v="center" class="pb-5">
          <b-col cols="12" md="6">
            <b-img-lazy
              src="/img/product-7.png"
              center
              class="prod-desc-image mb-5"
            >
            </b-img-lazy>
          </b-col>
          <b-col cols="12" md="6" data-aos="fade-up" data-aos-delay="250">
            <b-row class="blue-text justify-content-center">
              History and brush log
            </b-row>

            <b-row class="justify-content-center pt-3">
              <h1 style="max-width: 100%; text-align: center">
                Easily access all past brush events
              </h1>
            </b-row>
            <b-row
              class="
                justify-content-center
                align-center
                sub-title2
                pt-4
                pl-3
                pr-3
              "
            >
              The calendar view shows a more detailed history and enables you to
              locate past events.
            </b-row>
          </b-col>
        </b-row>

        <b-row align-v="center" class="pb-5">
          <b-col cols="12" md="6" class="hide-when-big">
            <b-img-lazy
              src="/img/product-8.png"
              center
              class="prod-desc-image mb-5"
            >
            </b-img-lazy>
          </b-col>
          <b-col cols="12" md="6" data-aos="fade-up" data-aos-delay="250">
            <b-row class="blue-text justify-content-center">
              Real-time analytics
            </b-row>

            <b-row class="justify-content-center pt-3">
              <h1 style="max-width: 100%; text-align: center">
                Detailed performance data for every brush
              </h1>
            </b-row>
            <b-row
              class="
                justify-content-center
                align-center
                sub-title2
                pt-4
                pl-3
                pr-3
              "
            >
              Truthbrush knows the difference between applying toothpaste,
              cleaning the brush and actual brushing. It’s important to brush
              for two minutes, not just hold the brush! It’s equally important
              to cover all sections of the mouth, with Truthbrush you will know.
            </b-row>
          </b-col>
          <b-col cols="12" md="6" class="hide-when-small">
            <b-img-lazy
              src="/img/product-8.png"
              center
              class="prod-desc-image mb-5"
            >
            </b-img-lazy>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row
      v-else-if="index == 1"
      class="main-jumbotron"
      style="padding-bottom: 120px"
    >
      <b-col cols="12" class="pl-pr-0-sm" style="padding-top: 60px">
        <b-row
          data-aos="fade"
          data-aos-delay="250"
          class="blue-text justify-content-center"
          style="color: #82c431"
        >
          Compare with other products
        </b-row>
      </b-col>

      <b-col
        cols="12"
        class="pl-pr-0-sm compare-table"
        style="padding-top: 30px"
      >
        <b-row
          data-aos="fade"
          data-aos-delay="250"
          class="justify-content-center pt-0 pb-3"
        >
          <h1 style="max-width: 800px; text-align: center">
            How the Truthbrush compares with a smart toothbrush
          </h1>
        </b-row>
        <b-row>
          <b-col cols="6" class="compare-table-left">
            <b-row data-aos="fade" data-aos-delay="50">
              <b-col>
                <b-img
                  center
                  src="img/traditional-smart.png"
                  style="max-width: 100%; height: 227px"
                ></b-img>
              </b-col>
            </b-row>
            <b-row class="pt-3 pb-3">
              <b>Smart toothbrush</b>
            </b-row>
          </b-col>
          <b-col cols="6" class="compare-table-right">
            <b-row data-aos="fade" data-aos-delay="200">
              <b-col>
                <b-img
                  center
                  src="img/truthbrush-smart.png"
                  style="max-width: 100%; height: 227px"
                ></b-img>
              </b-col>
            </b-row>
            <b-row class="pt-3 pb-3">
              <b>Truthbrush</b>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6" class="compare-table-left">
            <b-row class="compare-text">
              <p>
                <i class="fas fa-times fa-lg fa-fw red" aria-hidden="true"></i>
                Purchase and use the new brush
              </p>
            </b-row>
          </b-col>

          <b-col cols="6" class="compare-table-right">
            <b-row class="compare-text">
              <p>
                <i
                  class="fas fa-check fa-lg fa-fw green"
                  aria-hidden="true"
                ></i>
                Works on your existing brush
              </p>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6" class="compare-table-left">
            <b-row class="compare-text">
              <p>
                <i class="fas fa-times fa-lg fa-fw red" aria-hidden="true"></i>
                Watch your phone screen in bathroom
              </p>
            </b-row>
          </b-col>

          <b-col cols="6" class="compare-table-right">
            <b-row class="compare-text">
              <p>
                <i
                  class="fas fa-check fa-lg fa-fw green"
                  aria-hidden="true"
                ></i>
                No phone needed, tracking is in the background
              </p>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6" class="compare-table-left">
            <b-row class="compare-text">
              <p>
                <i class="fas fa-times fa-lg fa-fw red" aria-hidden="true"></i>
                App connects to one brush at a time
              </p>
            </b-row>
          </b-col>
          <b-col cols="6" class="compare-table-right">
            <b-row class="compare-text">
              <p>
                <i
                  class="fas fa-check fa-lg fa-fw green"
                  aria-hidden="true"
                ></i>
                Support multiple users at same time
              </p>
            </b-row>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6" class="compare-table-left">
            <b-row class="compare-text">
              <p>
                <i class="fas fa-times fa-lg fa-fw red" aria-hidden="true"></i>
                No data collection if phone is not near by
              </p>
            </b-row>
          </b-col>
          <b-col cols="6" class="compare-table-right">
            <b-row class="compare-text">
              <p>
                <i
                  class="fas fa-check fa-lg fa-fw green"
                  aria-hidden="true"
                ></i>
                Phone is not needed for data collection
              </p>
            </b-row>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6" class="compare-table-left">
            <b-row class="compare-text">
              <p>
                <i class="fas fa-times fa-lg fa-fw red" aria-hidden="true"></i>
                Require user to launch app and make sure Bluetooth is turned on
                to work
              </p>
            </b-row>
          </b-col>
          <b-col cols="6" class="compare-table-right">
            <b-row class="compare-text">
              <p>
                <i
                  class="fas fa-check fa-lg fa-fw green"
                  aria-hidden="true"
                ></i>
                Fully automatic! Just brush as normal. It knows when brushing
                starts and ends
              </p>
            </b-row>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6" class="compare-table-left">
            <b-row class="compare-text">
              <p>
                <i class="fas fa-times fa-lg fa-fw red" aria-hidden="true"></i>
                Less reliable connectivity
              </p>
            </b-row>
          </b-col>
          <b-col cols="6" class="compare-table-right">
            <b-row class="compare-text">
              <p>
                <i
                  class="fas fa-check fa-lg fa-fw green"
                  aria-hidden="true"
                ></i>
                Reliable connectivity with dedicated Hub
              </p>
            </b-row>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6" class="compare-table-left">
            <b-row class="compare-text">
              <p>
                <i class="fas fa-times fa-lg fa-fw red" aria-hidden="true"></i>
                Syncing and viewing of performance data is limited to the phone
                brush is setup with
              </p>
            </b-row>
          </b-col>
          <b-col cols="6" class="compare-table-right">
            <b-row class="compare-text">
              <p>
                <i
                  class="fas fa-check fa-lg fa-fw green"
                  aria-hidden="true"
                ></i>
                Performance data can be viewed by kids, parents and dentists, on
                their own devices
              </p>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row v-else-if="index == 2" class="main-jumbotron">
      <b-col cols="12" class="pl-pr-0-sm" style="padding-top: 60px">
        <b-row class="pb-5">
          <b-col cols="12" md="6">
            <b-img
              src="img/spec-1.png"
              center
              style="max-width: 100%; max-height: 350px"
            >
            </b-img>
          </b-col>
          <b-col cols="12" md="6">
            <b-img
              src="img/travel_hub_illustration.jpg"
              center
              style="max-width: 100%; max-height: 350px"
            >
            </b-img>
          </b-col>
        </b-row>
        <b-row
          style="border-top: 2px solid #f2f2f2; padding-bottom: 0px"
          class="pt-5"
        >
          <b-col cols="12" md="4" class="pb-3">
            <b style="font-size: 22px">Truthbrush Tracker</b>
          </b-col>
          <b-col cols="12" md="8">
            <b-row style="border-bottom: 2px solid #f2f2f2" class="pb-3">
              <b-col cols="12"><b>Dimension (Core)</b></b-col>
              <b-col cols="12">Diameter: 0.83 inch (21mm)</b-col>
              <b-col cols="12">Height: 0.23 inch (5.8mm)</b-col>
              <b-col cols="12">Weight: 0.16 oz (5g)</b-col>
            </b-row>
            <b-row style="border-bottom: 2px solid #f2f2f2" class="pt-3 pb-3">
              <b-col cols="12"><b>Attachment</b></b-col>
              <b-col cols="12"
                >Decorative silicone case with elastic ring</b-col
              >
            </b-row>
            <b-row style="border-bottom: 2px solid #f2f2f2" class="pt-3 pb-3">
              <b-col cols="12"><b>Brush handle fit</b></b-col>
              <b-col cols="12">0.32 inch to 1.2 inch in diameter</b-col>
            </b-row>

            <b-row style="border-bottom: 2px solid #f2f2f2" class="pt-3 pb-3">
              <b-col cols="12"><b>Wireless Technology</b></b-col>
              <b-col cols="12">Bluetooth LE</b-col>
            </b-row>

            <b-row style="border-bottom: 2px solid #f2f2f2" class="pt-3 pb-3">
              <b-col cols="12"><b>Water Resistant</b></b-col>
              <b-col cols="12">Yes</b-col>
            </b-row>

            <b-row style="border-bottom: 2px solid #f2f2f2" class="pt-3 pb-3">
              <b-col cols="12"><b>Battery Capacity</b></b-col>
              <b-col cols="12"
                >Tracker: up to 1 year, built-in battery. Tracker Pro: 6
                months per each battery, replaceable<sup>1</sup>.</b-col
              >
            </b-row>

            <b-row style="border-bottom: 2px solid #f2f2f2" class="pt-3 pb-3">
              <b-col cols="12"><b>Battery Type</b></b-col>
              <b-col cols="12"
                >Tracker: Built-in. Tracker Pro: Standard CR1620
                replaceable.</b-col
              >
            </b-row>

            <b-row style="border-bottom: 2px solid #f2f2f2" class="pt-3 pb-3">
              <b-col cols="12"><b>SoC</b></b-col>
              <b-col cols="12"
                >64MHz ARM@ CorTexTM-M4F with 256KB Flash + 32KB Ram, ultra-low
                power. Sensitivity LE -96 dbm</b-col
              >
            </b-row>

            <b-row style="border-bottom: 2px solid #f2f2f2" class="pt-3 pb-3">
              <b-col cols="12"><b>Sensor</b></b-col>
              <b-col cols="12">Temperature, Motion</b-col>
            </b-row>

            <b-row style="border-bottom: 2px solid #f2f2f2" class="pt-3 pb-3">
              <b-col cols="12"><b>Operating Temperature</b></b-col>
              <b-col cols="12">40 to 100F</b-col>
            </b-row>

            <b-row style="border-bottom: 2px solid #f2f2f2" class="pt-3 pb-3">
              <b-col cols="12"><b>Peripheral</b></b-col>
              <b-col cols="12">Built-in buzzer and timer</b-col>
            </b-row>

            <b-row style="border-bottom: 2px solid #f2f2f2" class="pt-3 pb-3">
              <b-col cols="12"><b>Hardware Interface</b></b-col>
              <b-col cols="12">Button</b-col>
            </b-row>

            <b-row style="border-bottom: 2px solid #f2f2f2" class="pt-3 pb-3">
              <b-col cols="12"><b>Signal Processing</b></b-col>
              <b-col cols="12">Gesture recognition</b-col>
              <b-col cols="12">Quadrant coverage </b-col>
              <b-col cols="12">Technique analysis </b-col>
              <b-col cols="12">Duration analysis </b-col>
              <b-col cols="12">Engagement analysis </b-col>
              <b-col cols="12">Consistency analysis </b-col>
              <b-col cols="12">Efficiency analysis</b-col>
              <b-col cols="12">Ranking analysis </b-col>
              <b-col cols="12">False-positive detection </b-col>
              <b-col cols="12"
                ><b>** All signal processing performed securely in the cloud</b>
              </b-col>
            </b-row>

            <b-row style="border-bottom: 2px solid #f2f2f2" class="pt-3 pb-3">
              <b-col cols="12"><b>Setup</b></b-col>
              <b-col cols="12">
                Via smart phone. At least one Hub is required.
              </b-col>
            </b-row>

            <b-row style="border-bottom: 0px solid #f2f2f2" class="pt-3 pb-3">
              <b-col cols="12"><b>Data Collection</b></b-col>
              <b-col cols="12">
                Via Hub. No phone required for data collection after setup.
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row
          style="border-top: 2px solid #f2f2f2; padding-bottom: 120px"
          class="pt-5"
        >
          <b-col cols="12" md="4" class="pb-3">
            <b style="font-size: 22px"
              >Truthbrush Hub (Required for Trackers to work)
            </b>
          </b-col>
          <b-col cols="12" md="8">
            <b-row style="border-bottom: 2px solid #f2f2f2" class="pb-3">
              <b-col cols="12"><b>Dimension</b></b-col>
              <b-col cols="12"
                >1.5 inch (38mm) by 0.4 inch (10mm) by 1.0 inch
                (25mm)
              </b-col>
            </b-row>
            <b-row style="border-bottom: 2px solid #f2f2f2" class="pt-3 pb-3">
              <b-col cols="12"><b>Operating Voltage</b></b-col>
              <b-col cols="12">5v DC 500mA</b-col>
            </b-row>
            <b-row style="border-bottom: 2px solid #f2f2f2" class="pt-3 pb-3">
              <b-col cols="12"><b>Plug Type</b></b-col>
              <b-col cols="12">USB</b-col>
            </b-row>

            <b-row style="border-bottom: 2px solid #f2f2f2" class="pt-3 pb-3">
              <b-col cols="12"><b>LED </b></b-col>
              <b-col cols="12">2</b-col>
            </b-row>

            <b-row style="border-bottom: 2px solid #f2f2f2" class="pt-3 pb-3">
              <b-col cols="12"><b>Wireless Technology</b></b-col>
              <b-col cols="12">Bluetooth LE, Wifi (2.4GHz band)</b-col>
            </b-row>

            <b-row style="border-bottom: 2px solid #f2f2f2" class="pt-3 pb-3">
              <b-col cols="12"><b>Authentication</b></b-col>
              <b-col cols="12">WPA1/WPA2</b-col>
            </b-row>

            <b-row style="border-bottom: 2px solid #f2f2f2" class="pt-3 pb-3">
              <b-col cols="12"><b>Protocol & Security</b></b-col>
              <b-col cols="12">MQTT SSL/TLS</b-col>
            </b-row>

            <b-row style="border-bottom: 2px solid #f2f2f2" class="pt-3 pb-3">
              <b-col cols="12"><b>Onboard software</b></b-col>
              <b-col cols="12">Over-the-air upgradable</b-col>
            </b-row>

            <b-row style="border-bottom: 2px solid #f2f2f2" class="pt-3 pb-3">
              <b-col cols="12"><b>Working Distance</b></b-col>
              <b-col cols="12">Up to 30 feet from tracker</b-col>
            </b-row>

            <b-row style="border-bottom: 2px solid #f2f2f2" class="pt-3 pb-3">
              <b-col cols="12"><b>Soc</b></b-col>
              <b-col cols="12">
                ESP32-D0WD at 40MHz with 4MB Flash, with integrated antenna at
                2.4GHz frequency</b-col
              >
            </b-row>

            <b-row style="border-bottom: 2px solid #f2f2f2" class="pt-3 pb-3">
              <b-col cols="12"><b>Number of Trackers Supported</b></b-col>
              <b-col cols="12"> Support up to 25 simultaneously</b-col>
            </b-row>

            <b-row style="border-bottom: 2px solid #f2f2f2" class="pt-3 pb-3">
              <b-col cols="12"><b>Multiple Hub Deployment</b></b-col>
              <b-col cols="12">
                Yes, multiple Hubs can be added to extend coverage area.
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row
            align-h="center"
            style="width: 100%; margin-top: 40px; margin-bottom: 60px"
          >
            <b-col
              cols="12"
              style="padding-top: 5px"
              class="pl-0 pr-0 cart-nav"
            >
              <ol style="color: #4f4f4f; font-size: 10px; padding-left: 15px">
                <li style="font-size: 10px">
                  Testing conducted by Truthbrush in Feb 2022 using preproduction Truthbrush Classic and Pro Trackers and software. Battery life based on an everyday use of two brushing events with two minutes brushing duration each under excellent Bluetooth and Wifi connection. Traveling with a tracker turned on and poor connectivity with Hub may result in significant battery drainage. Battery life varies with usage, environmental conditions, replacement battery manufacturer, and many other factors; actual results will vary.
                </li>
                
              </ol>
            </b-col>
          </b-row>
      </b-col>
    </b-row>
    <b-row
      v-else-if="index == 3"
      class="main-jumbotron"
      style="padding-bottom: 120px"
    >
      <b-col cols="12" class="reduced_pl_pr" style="padding-top: 60px">
        <b-row
          data-aos="fade-right"
          data-aos-delay="250"
          class="blue-text justify-content-center"
          style="color: #12b8ed"
        >
          How it works
        </b-row>

        <b-row
          data-aos="fade-right"
          data-aos-delay="350"
          class="justify-content-center pt-3"
        >
          <h1 style="max-width: 800px">Easy to setup, easy to use</h1>
        </b-row>
        <b-row
          data-aos="fade-right"
          data-aos-delay="450"
          class="justify-content-center align-center pt-4 sub-title2 pl-3 pr-2"
          style="max-width: 800px; margin: auto !important"
        >
          Truthbrush is designed to collect brush data over time. Identifying
          patterns with accurate, reliable information allows you to make the
          right adjustments. The hub unit can be plugged into any wall outlet
          and connects to your wifi. It passively collects and passes all brush
          data to a secure server where it can be analyzed and made available
          for viewing in your mobile app or by your dentist.
        </b-row>
        <b-row
          style="
            width: 100%;
            position: relative;
            padding-bottom: 60px;
            padding-top: 80px;
          "
          align-h="center"
          class="main-jumbotron reduced-pb-0"
        >
          <b-col class="pl-0 pr-0 wrapper">
            <div
              style="
                position: relative;
                width: 100%;
                height: 0px;
                padding-bottom: 56.25%;
              "
            >
              <iframe
                style="
                  position: absolute;
                  left: 0;
                  top: 0;
                  width: 100%;
                  height: 100%;
                "
                frameborder="0"
                src="https://www.youtube.com/embed/ehGOq4PjOKQ"
              >
              </iframe>
            </div>
          </b-col>
        </b-row>

        <b-row
          style="
            width: 100%;
            padding-top: 80px;
            padding-bottom: 120px;
            background-color: #f9f9f9;
          "
          align-h="center"
        >
          <b-col cols="12" style="max-width: 1200px" class="reduced_pl_pr">
            <b-row align-h="center" class="pb-5">
              <b-col md="12" class="reduced_pl_pr">
                <h1
                  style="margin: auto; text-align: center"
                  data-aos="fade-right"
                  data-aos-offset="250"
                  data-aos-delay="50"
                >
                  Creating healthy habits with Truthbrush
                </h1>
              </b-col>
            </b-row>
            <b-row align-h="center">
              <b-col class="no-h-padding-small">
                <b-img src="img/group-2.png" fluid center></b-img>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row style="width: 100%">
      <nav-footer></nav-footer>
    </b-row>
    <b-row>
        <b-modal id="trust-verify" hide-backdrop size="xl" centered title="BootstrapVue">
          <b-embed
            type="iframe"
            aspect="16by9"
            src="https://www.youtube.com/embed/sPvg7CZKogw"
            allowfullscreen
          ></b-embed>
        </b-modal>
      </b-row>
  </b-container>
</template>

<script>
import NavHeader from "./../components/NavHeader";
import NavFooter from "./../components/NavFooter";
//import { Carousel, Slide } from "vue-carousel";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  name: "Home",
  components: {
    NavHeader,
    NavFooter,
    VueSlickCarousel,
    //Carousel,
    //Slide,
  },
  data() {
    return {
      index: 0,
      slide: 0,
      paginationColor: "#12B8ED",
      style: [
        "#5DBEB5",
        "#C46A95",
        "#82C431",
        "#C46A95",
        "#1865BF",
        "#F08507",
        "#917CCE",
      ],
    };
  },
  methods: {
    onPageChange(val) {
      val = Math.floor((val)).toFixed(0)
      this.$store.slidepage = val;
      this.$refs.header.updateLogoProductPage(val);
      this.slide = val;
    },
    /*
    video_init() {
      window._wq = window._wq || [];
      var context = this;
      window._wq.push({
        id: "zvkx0dtjv0",
        onReady: function (video) {
          context.video1 = video;
        },
      });

      window._wq.push({
        id: "xf65loyzdr",
        onReady: function (video) {
          context.video2 = video;
        },
      });
    },
    video1_start() {
      this.video1.play();
    },
    video2_start() {
      this.video2.play();
    },

    */
    getbuybuttonstyle() {
      return "background-color:" + this.style[this.slide] + ";border: 0px";
    },
  },
  mounted() {
    /*
    let recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute(
      "src",
      "https://fast.wistia.com/assets/external/E-v1.js"
    );

    document.head.appendChild(recaptchaScript);

    this.video_init();
    */
    this.onPageChange(0);
  },
};
</script>

<style lang="scss">
#trust-verify{
 header, footer{
  display:none
 }
 .modal-body{
  padding:0
 }
}
.product-tab button {
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 25px;
}

.button-unselect {
  background-color: transparent !important;
  border-color: transparent !important;
}

.product-tab a {
  padding-right: 0 !important;
}

.main-jumbotron h1 {
  margin-top: auto;
  margin-bottom: auto;
  font-size: 34px !important;
}

.main-jumbotron .sub-title2 {
  font-size: 18px !important;
}

@media (max-width: 999px) {
  .navbar-nav,
  h1 {
    margin: 0 auto;
  }
  .nav-buy-button {
    display: none;
  }

  .product-tab button {
    padding-left: 8px;
    padding-right: 8px;
    border-radius: 25px;
  }
}

.product-sub-image {
  width: 120px;
  height: 120px;
}

.background-product-2 {
  background-image: url(/img/product-hero2-min.jpg);
  background-position: 23% 50%;
  background-repeat: no-repeat;
  margin-bottom: 0px !important;
  background-size: cover;
}

.product-rainbow {
  background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%),
    linear-gradient(343.13deg, rgba(177, 236, 255, 0.4) -4.45%, #eeffd9 75.76%);
  .row {
    padding-left: 5%;
    padding-right: 5%;
  }
}

.prod-desc-image {
  max-height: 600px;
  max-width: 100%;
}

@media (min-width: 769px) {
  .hide-when-big {
    display: none !important;
  }

  .hide-when-small {
    display: auto !important;
  }

  .min-height-sp {
    min-height: 800px;
  }
}

@media (max-width: 768px) {
  .min-height-sp {
    min-height: 680px;
  }

  .h-padding-small {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  .hide-when-big {
    display: auto !important;
  }
  .hide-when-small {
    display: none !important;
  }

  .justify-content-center h1,
  .justify-content-center {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }

  .product-rainbow > .row {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .compare-text p {
    padding-left: 5px;
    padding-right: 5px;
    text-align: left;
    font-size: 14px !important;
  }
  .justify-content-center h1 {
    text-align: center;
  }

  .reduced-pt-20 {
    padding-top: 20px !important;
  }
  .prod-desc-image {
    max-height: 400px;
  }

  .reduced_pl_pr {
    padding-left: 0 !important;
    padding-right: 0;
  }
  .prod-card {
    height: 300px !important;
    background-size: cover !important;
  }

  .main-jumbotron h1 {
    margin-top: auto;
    margin-bottom: auto;
    font-size: 28px !important;
  }
}

.btn-light {
  background-color: #f2f2f2;
  border-color: #f2f2f2;
}
.compare-table b {
  text-align: center;
  margin: 0 auto;
}

.compare-table-left {
  padding-left: 0 !important;
  padding-right: 0 !important;
  border-right: 1px solid #f2f2f2;
  border-bottom: 2px solid #f2f2f2;
}

.compare-table-right {
  padding-left: 0 !important;
  padding-right: 0 !important;
  border-left: 1px solid #f2f2f2;
  border-bottom: 2px solid #f2f2f2;
}

.compare-text {
  color: #4f4f4f;
  text-align: center;
  justify-content: center;
  padding-top: 20px;
  padding-bottom: 20px;

  .fa-lg {
    margin-right: 15px;
    margin-left: 15px;
  }
}

.green {
  color: #82c431;
}
.red {
  color: #c6471f;
}

.prod-card {
  height: 600px;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  margin-bottom: 0px !important;
  background-size: cover;
}

.card-1 {
  background-image: url(/img/product-renderings-09-min.jpg);
  background-repeat: no-repeat;
  background-position: 62% 50%;
  margin-bottom: 0px !important;
  background-size: contain;
}

.card-2 {
  background-image: url(/img/product-renderings-02-min.jpg);
  background-repeat: no-repeat;
  background-position: 58% 50%;
  margin-bottom: 0px !important;
  background-size: contain;
}
.card-3 {
  background-image: url(/img/product-renderings-08-min.jpg);
  background-repeat: no-repeat;
  margin-bottom: 0px !important;
  background-position: 44% 50%;
  background-size: contain;
}
.card-4 {
  background-image: url(/img/product-renderings-04-min.jpg);
  background-repeat: no-repeat;
  margin-bottom: 0px !important;
  background-size: contain;
}
.card-5 {
  background-image: url(/img/product-renderings-05-min.jpg);
  background-size: contain;
}
.card-6 {
  background-image: url(/img/product-renderings-06-min.jpg);
  background-size: contain;
  background-position: 40% 50%;
}
.card-7 {
  background-image: url(/img/product-renderings-11-min.jpg);
  background-size: contain;
  background-position: 50% 50%;
}
.card-8 {
  background-image: url(/img/product-renderings-10-min.jpg);
  background-size: contain;
}

.card-9 {
  background-image: url(/img/product-renderings-07-min.jpg);
  background-size: contain;
}
</style>